import {
  CARD,
  IMAGE,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Images9: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        columns.items.push({
          id: 'LAYOUT_LIST',
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                height: '90%',
                width: '90%',
                padding: '0px',
                minHeight: '300px'
              },
              items: [
                {
                  id: 'img',
                  type: IMAGE,
                  values: {
                    url: item.pictures?.[0].mediaUrl,
                    alt: item.pictures?.[0].name
                  },
                  items: []
                }
              ]
            }
          ]
        });
        break;
      case 'Text':
      case 'Question':
        columns.items.push({
          id: 'LAYOUT_LIST_RIGHT',
          type: LAYOUT_LIST,
          values: {
            align: 'left',
            padded: true,
            card: 'lg'
          },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading2'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });
  root.items.push(columns);
  return root;
};
